import React, { FC, useEffect, useState } from 'react';
import { ProgressBarProps } from '~/core/dto/components/progressBarDTO';
import check from '~/assets/icons/Check.svg';

import './ProgressBar.styles.css';

const ProgressBar: FC<ProgressBarProps> = ( {
  duration, title, stopped, onDone,
} ) => {

  const [ progress, setProgress ] = useState( 0 );

  useEffect( () => {

    const interval = setInterval( () => {

      setProgress( ( oldProgress ) => Math.min( oldProgress + 1, 100 ) );

    }, duration / 100 );

    if ( stopped ) {

      clearInterval( interval );

    }

    return () => {

      clearInterval( interval );

    };

  }, [ stopped ] );

  useEffect( () => {

    if ( progress === 100 ) {

      onDone();

    }

  }, [ progress ] );

  return (
    <div className="progressBarComponent">
      <div className="progressBarContainer">
        <p className="progressBarTitle">{title}</p>
        {progress === 100
          ? <div className="progressBar100"><img src={check} alt="Check" /></div>
          : <p className="progressBarPercentage">{`${progress}%`}</p>}
      </div>
      {progress !== 100 && (
        <div className="progressBar">
          <div className="progressBarFill" style={{ width: `${progress}%` }} />
        </div>
      )}
    </div>
  );

};

export default ProgressBar;
